// extracted by mini-css-extract-plugin
export default {"container":"CardsLayout_container__S4wZ5","flexGrid":"CardsLayout_flexGrid__DGtGM"};